<template>
  <div :class="inDealer ? '' : 'content-container'">
    <el-breadcrumb v-if="!inDealer" separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <h6 class="content-header">客户</h6> -->
    <div class="panel mt-20" v-if="!inDealer || customers.length > 10">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="客户名" prop="name">
            <el-input
              size="small"
              v-model="filter.name"
              autocomplete="off"
              @keyup.enter.native="reqeustCustomers"
            ></el-input>
          </el-form-item>
          <el-form-item label="中间商" prop="dealer_id" v-if="!inDealer">
            <dealer-select
              :val="filter.dealer_id"
              @change="filter.dealer_id = $event"
            ></dealer-select>
          </el-form-item>
          <el-form-item label="销售" prop="user_id">
            <user-select
              :val="filter.user_id"
              @change="filter.user_id = $event"
            ></user-select>
          </el-form-item>
          <el-form-item
            label="区域"
            prop="area_id"
            v-if="auth.isPlatformUser()"
          >
            <el-select
              v-model="filter.area_id"
              size="small"
              placeholder="选择区域"
              :clearable="true"
            >
              <el-option
                v-for="(value, index) in AreaTextMap"
                :key="index"
                :label="value"
                :value="parseInt(index)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省市区" prop="area">
            <el-cascader
              style="width: 100%"
              size="small"
              class="long"
              :options="regionDataPlus"
              v-model="filter.area"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="拥有设备" prop="item_category_id">
            <item-category-select
              :val="filter.item_category_id"
              :category="2"
              @change="filter.item_category_id = $event"
            ></item-category-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="filter.status"
              size="small"
              placeholder="请选择"
              style="width: 100%"
              :clearable="true"
            >
              <el-option
                v-for="(value, index) in CustomerStatusMap"
                :key="index"
                :label="value"
                :value="parseInt(index)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类型">
            <el-select
              v-model="filter.category"
              size="small"
              placeholder="请选择"
              style="width: 100%"
              :clearable="true"
            >
              <el-option
                v-for="(value, index) in CustomerCategroyMap"
                :key="index"
                :label="value"
                :value="parseInt(index)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              reqeustCustomers()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
          <el-button
            v-if="!noFilter"
            type="text"
            size="mini"
            class="text-primary"
            @click="batchPanelVisible = !batchPanelVisible"
          >
            批量操作此筛选结果
            <i class="el-icon-bottom el-icon--right"></i>
          </el-button>
        </div>
        <div class="warn-panel mt-20 text-info-12" v-if="batchPanelVisible">
          <div>当前筛选结果{{ total }}条数据，批量进行如下操作：</div>
          <div class="mt-10">
            <span>转移到新的销售</span>
            <user-select
              class="ml-10"
              :val="batch.transfer"
              @change="batch.transfer = $event"
            ></user-select>
          </div>
          <el-button
            class="mt-10"
            type="primary"
            size="small"
            @click="batchAction()"
            >确认操作</el-button
          >
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startCustomerFomer()"
          >新客户</el-button
        >
        <file-button
          style="float: right"
          obj="customer"
          :filter="filter"
          class="mobile-hide"
          @importCallback="importCallback"
        ></file-button>
      </div>
      <el-table
        v-if="!isMobile()"
        :data="customers"
        v-loading="loading"
        class="mt-10"
      >
        <el-table-column prop="name" label="客户名称 / 地址" min-width="200">
          <template slot-scope="scope">
            <customer-link :customer="scope.row"></customer-link>
            <br />
            {{ AreaTextMap[scope.row.area_id] }}
            {{ CodeToText[scope.row.province] }}{{ CodeToText[scope.row.city]
            }}{{ CodeToText[scope.row.county] }} {{ scope.row.address_detail }}
          </template>
        </el-table-column>
        <el-table-column
          prop="device_count"
          label="设备数量"
          align="center"
        ></el-table-column>
        <el-table-column prop="dealer.name" label="中间商" align="left">
          <template slot-scope="scope">{{
            scope.row.dealer_id == 0 ? '' : scope.row.dealer.name
          }}</template>
        </el-table-column>
        <el-table-column prop="fee" label="销售" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="industry"
          label="行业"
          align="center"
        ></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <status-tag
              class="font-12"
              :type="scope.row.status == 1 ? 'success' : 'danger'"
              :name="CustomerStatusMap[scope.row.status]"
            ></status-tag>
          </template>
        </el-table-column>

        <el-table-column
          align="right"
          label="操作"
          width="100"
          class-name="mobile-hide"
        >
          <template slot-scope="scope">
            <router-link
              :to="{ path: '/dashboard/admin/customers/' + scope.row.id }"
              class="text-primary"
              style="font-size: 12px"
            >
              <el-button size="mini" type="primary" plain>查看详情</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in customers">
          <router-link
            :to="{ path: '/dashboard/admin/customers/' + item.id }"
            class="flex-row-between"
          >
            <div>
              <div>{{ item.name }}</div>
              <div class="text-secondary font-12">
                <!-- <span>{{ item.dealer_id == 0 ? '平台' : item.dealer.name }}</span> -->
                <span v-if="item.industry.length > 0"
                  >&middot;{{ item.industry }}</span
                >
              </div>
              <div class="text-info-12">
                {{ CodeToText[item.province] }}{{ CodeToText[item.city]
                }}{{ CodeToText[item.county] }}
                {{ item.address_detail }}
              </div>
            </div>
            <div style="width: 80px; text-align: right; font-size: 12px">
              <span>{{ item.user.name }}</span>
            </div>
          </router-link>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <customer-former
      :model="customerForm"
      :show.sync="addCustomerFormVisible"
      @createdCustomer="createdCustomer"
    ></customer-former>
  </div>
</template>

<script>
import { getStore } from '@/config/storage'
import {
  createCustomer,
  customerList,
  customerBatchTransfer,
} from '../../service/getData'
import { regionDataPlus } from '@/util/area_tool'
import CustomerFormer from '@/components/customer'
import DealerSelect from '@/components/select/dealer_select'
import UserSelect from '@/components/select/user_select'
import ItemCategorySelect from '@/components/select/item_category_select'
import auth from '@/util/auth'
import { CodeToText } from '@/util/area_tool'
import { isMobile } from '@/util/index'
import {
  AreaTextMap,
  CustomerStatusMap,
  CustomerCategroyMap,
} from '@/config/global'

export default {
  props: {
    dealerID: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CustomerFormer,
    DealerSelect,
    UserSelect,
    ItemCategorySelect,
  },
  data() {
    return {
      regionDataPlus,
      filter: {
        name: '',
        dealer_id: null,
        area_id: null,
        user_id: null,
        item_category_id: null,
        category: null,
        area: [],
        size: 20,
        status: null,
        page: 1,
      },
      batch: {
        transfer: null,
      },
      batchPanelVisible: false,
      isMobile,
      CodeToText,
      AreaTextMap,
      CustomerStatusMap,
      CustomerCategroyMap,
      total: 0,
      customers: [],
      auth,
      customerForm: {},
      addCustomerFormVisible: false,
      loading: false,
    }
  },
  computed: {
    noFilter() {
      return (
        this.filter.name.length == 0 &&
        !this.filter.dealer_id &&
        !this.filter.area_id &&
        !this.filter.user_id &&
        !this.filter.item_category_id &&
        (!this.filter.area || this.filter.area.length == 0)
      )
    },
    inDealer() {
      return this.dealerID > 0
    },
  },
  watch: {
    // $route(to, from) {
    //   this.filter.dealer_id = ''
    //   this.reqeustCustomers()
    // },
    'filter.page': function () {
      this.reqeustCustomers()
    },
  },
  created() {
    let area_id = parseInt(this.$route.query.area_id || 0)
    if (area_id == 0) {
      area_id = null
    }
    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
      dealer_id: parseInt(this.$route.query.dealer_id || 0),
      item_category_id: parseInt(this.$route.query.item_category_id || 0),
      name: this.$route.query.name || '',
      status: parseInt(this.$route.query.status || 0) || '',
      category: parseInt(this.$route.query.category || 0) || '',
      area_id: area_id,
      user_id: parseInt(this.$route.query.user_id || 0),
      area: this.$route.query.area || [],
    }

    this.reqeustCustomers()
    // let dealerID = this.$route.query.dealer_id
    // if (dealerID) {
    //   this.$nextTick(() => {
    //     this.filter.dealer_id = parseInt(dealerID)
    //     this.reqeustCustomers()
    //   })
    // } else {
    //   this.reqeustCustomers()
    // }
  },
  methods: {
    async reqeustCustomers() {
      this.$router.replace({
        query: this.filter,
      })

      let data = {
        size: this.filter.size,
        page: this.filter.page - 1,
        name: this.filter.name,
        dealer_id:
          this.dealerID > 0 ? this.dealerID : this.filter.dealer_id || 0,
        area_id: this.filter.area_id || 0,
        user_id: this.filter.user_id || 0,
        status: this.filter.status || 0,
        category: this.filter.category || 0,
        special_mark: -1,
        item_category_id: this.filter.item_category_id || 0,
      }
      let area = this.filter.area
      if (area.length > 0) {
        data.province = area[0]
      }
      if (area.length > 1) {
        data.city = area[1]
      }
      if (area.length > 2) {
        data.county = area[2]
      }
      this.loading = true

      let res = await customerList(data)
      if (res.code == 0) {
        this.customers = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    async requestDevices(query) {
      if (query !== '') {
        this.deviceLoading = true
        let data = {
          query: query,
          page: 0,
          size: 10,
          category: 2,
        }
        let res = await itemCategoryList(data)
        this.deviceLoading = false
        this.devices = res.data.list
      } else {
        this.devices = []
      }
    },
    startCustomerFomer() {
      this.customerForm = {
        name: '',
        dealer_id: this.dealerID,
        area_id: 0,
        industry: '',
        source: '',
        scale: '',
        remark: '',
        status: 1,
        category: 1,
        area: [],
        address_detail: '',
      }
      this.addCustomerFormVisible = true
    },
    async batchAction() {
      if (this.total == 0) {
        this.$message.error('没有客户需要转移')
        return
      }

      if (!this.batch.transfer || this.batch.transfer == 0) {
        this.$message.error('请选择转移目标销售')
        return
      }
      let data = {
        name: this.filter.name,
        dealer_id: this.filter.dealer_id || 0,
        area_id: this.filter.area_id || 0,
        user_id: this.filter.user_id || 0,
        item_category_id: this.filter.item_category_id || 0,
        target_id: this.batch.transfer,
      }

      var that = this
      this.$confirm('是否确定提交' + this.total + '条数据修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        customerBatchTransfer(data).then((res) => {
          if (res.code == 0) {
            that.batch.transfer = null
            that.$message({ message: '操作成功', type: 'success' })
            that.reqeustCustomers()
          }
        })
      })
    },
    createdCustomer(customer) {
      this.customers.unshift(customer)
    },
    reset() {
      this.filter = {
        name: '',
        dealer_id: null,
        area_id: null,
        user_id: null,
        item_category_id: null,
        area: [],
        size: 20,
        page: 1,
      }
      this.reqeustCustomers()
    },
    importCallback(res) {
      if (res.code == 0) {
        this.reset()
      }
    },
  },
}
</script>

<style scoped>
</style>